import { useEffect, useState } from "react";
import api from "../api";
import { Search } from 'lucide-react';
import Pagination from '../components/Pagination';

function PendingApprovalList() {
  const [pendingExpenses, setPendingExpenses] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState('');
  const itemsPerPage = 10;
  
  useEffect(() => {
    const fetchPendingExpenses = async () => {
      try {
        const res = await api.get("/api/approvals/pending");
        setPendingExpenses(res.data);
      } catch (error) {
        console.error("❌ Error fetching pending expenses:", error);
      }
    };
    fetchPendingExpenses();
  }, []);

  const isPendingStatus = (status) => {
    if (!status) return false;
    const s = String(status).trim().toLowerCase();
    return s === 'pending' || s.startsWith('pending level');
  };

  const filteredExpenses = pendingExpenses
    .filter(exp => isPendingStatus(exp.status))
    .filter(exp =>
      (exp.expense_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
       exp.expense_name?.toLowerCase().includes(searchTerm.toLowerCase()))
    )
    .sort((a, b) => {
      const ta = a?.date ? new Date(a.date).getTime() : (a?.created_at ? new Date(a.created_at).getTime() : 0);
      const tb = b?.date ? new Date(b.date).getTime() : (b?.created_at ? new Date(b.created_at).getTime() : 0);
      if (tb !== ta) return tb - ta;
      const numA = parseInt((a?.expense_id || '').match(/(\d+)$/)?.[1] || '0', 10);
      const numB = parseInt((b?.expense_id || '').match(/(\d+)$/)?.[1] || '0', 10);
      return numB - numA;
    });
  
  const totalPages = Math.ceil(filteredExpenses.length / itemsPerPage);
  const currentItems = filteredExpenses.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );
  
  return (
    <div className="p-6 w-full space-y-6" style={{ color: 'var(--text)' }}>
      <div>
        <h1 className="text-2xl font-bold mb-1" style={{ color: 'var(--heading-color, var(--text))' }}>Pending Expenses</h1>
        <p className="text-sm" style={{ color: 'var(--muted)' }}>List of expenses awaiting approval action</p>
      </div>
        <div className="relative mb-6 w-full md:w-1/3">
          <Search className="absolute top-2.5 left-3" style={{ color: 'var(--muted)' }} />
          <input
            type="text"
            className="pl-10 pr-4 py-2 rounded-md w-full shadow-sm focus:outline-none"
            style={{ background: 'var(--panel)', color: 'var(--text)', border: '1px solid var(--border)' }}
            placeholder="Search expenses by ID or Name..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>
      <div className="rounded-xl shadow-sm border p-4" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
        {filteredExpenses.length === 0 ? (
          <p className="text-center py-8" style={{ color: 'var(--muted)' }}>No pending expenses found.</p>
        ) : (
          <>
            <div className="overflow-x-auto rounded-lg">
              <table className="min-w-full" style={{ color: 'var(--text)' }}>
                <thead className="border-b" style={{ background: 'var(--panel)', borderColor: 'var(--border)' }}>
                  <tr>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Creator User ID
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Expense ID
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Expense Name
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Date
                    </th>
                    <th scope="col" className="px-6 py-3 text-left text-sm font-semibold tracking-wider">
                      Status
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {currentItems.map((exp) => (
                    <tr key={exp.expense_id} className="border-b" style={{ borderColor: 'var(--border)' }}>
                      <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">{exp.creator_user_id}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: 'var(--muted)' }}>{exp.expense_id}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: 'var(--muted)' }}>{exp.expense_name}</td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm" style={{ color: 'var(--muted)' }}>
                        {exp.date ? new Date(exp.date).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"}
                      </td>
                      <td className="px-6 py-4 whitespace-nowrap text-sm">
                        <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full"
                          style={{ background: 'rgba(234,179,8,0.18)', color: '#a16207' }}>
                          {exp.status}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            
            <div className="mt-4">
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={(p) => setCurrentPage(p)}
                totalItems={filteredExpenses.length}
                itemsPerPage={itemsPerPage}
              />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
  
export default PendingApprovalList;




// import { useEffect, useState } from "react";
// import axios from "axios";
// import { Search } from 'lucide-react';

// function PendingApprovalList() {
//   const [pendingExpenses, setPendingExpenses] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [searchTerm, setSearchTerm] = useState('');
//   const itemsPerPage = 10;

//   useEffect(() => {
//     const fetchPendingExpenses = async () => {
//       try {
//         const res = await axios.get("http://localhost:5000/api/approvals/pending");
//         setPendingExpenses(res.data);
//       } catch (error) {
//         console.error("❌ Error fetching pending expenses:", error);
//         // Using a custom modal or message box instead of alert()
//         // For simplicity, a console log is used here, but in a real app,
//         // you'd display a user-friendly message in the UI.
//         console.log("Failed to load pending expenses. Please try again.");
//       }
//     };
//     fetchPendingExpenses();
//   }, []);

//   // Filter expenses based on the search term
//   const filteredExpenses = pendingExpenses.filter(exp =>
//     (exp.expense_id?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//     exp.expense_name?.toLowerCase().includes(searchTerm.toLowerCase()))
//   );

//   // Calculate total pages based on filtered expenses
//   const totalPages = Math.ceil(filteredExpenses.length / itemsPerPage);
//   // Get current items for the table based on filtered expenses
//   const currentItems = filteredExpenses.slice(
//     (currentPage - 1) * itemsPerPage,
//     currentPage * itemsPerPage
//   );

//   return (
//     <div className="p-6 bg-gray-50 min-h-screen font-sans">
//       {/* Main container for the card-like appearance */}
//       <div className="max-w-7xl mx-auto bg-white p-6 rounded-lg shadow-sm">
//         <h2 className="text-2xl font-bold mb-6 text-gray-800">Pending Expenses</h2>

//         <div className="relative mb-6 w-full max-w-sm">
//           <Search className="absolute top-1/2 -translate-y-1/2 left-3 text-gray-400 w-5 h-5" />
//           <input
//             type="text"
//             className="pl-10 pr-4 py-2 border border-gray-300 rounded-md w-full text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition"
//             placeholder="Search expenses by ID or Name..."
//             value={searchTerm}
//             onChange={(e) => setSearchTerm(e.target.value)}
//           />
//         </div>

//         {/* This div now correctly wraps the conditional rendering for the table/message */}
//         {filteredExpenses.length === 0 ? (
//           <p className="text-gray-500 text-center py-8">No pending expenses found.</p>
//         ) : (
//           <>
//             <div className="overflow-x-auto border border-gray-200 rounded-lg">
//               <table className="min-w-full divide-y divide-gray-200">
//                 <thead className="bg-gray-50"> {/* Changed back to bg-gray-50 for consistency */}
//                   <tr>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Creator User ID
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Expense ID
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Expense Name
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Date
//                     </th>
//                     <th scope="col" className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
//                       Status
//                     </th>
//                   </tr>
//                 </thead>
//                 <tbody className="bg-white divide-y divide-gray-200">
//                   {currentItems.map((exp) => (
//                     <tr key={exp.expense_id} className="hover:bg-gray-50">
//                       <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{exp.creator_user_id}</td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{exp.expense_id}</td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{exp.expense_name}</td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
//                         {exp.date ? new Date(exp.date).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' }) : "-"}
//                       </td>
//                       <td className="px-6 py-4 whitespace-nowrap text-sm">
//                         <span className="px-2 inline-flex text-xs leading-5 font-semibold rounded-full bg-yellow-100 text-yellow-800">
//                           {exp.status}
//                         </span>
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             </div>

//             <div className="flex items-center justify-between mt-6">
//               <button
//                 className="px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
//                 onClick={() => setCurrentPage((p) => Math.max(1, p - 1))}
//                 disabled={currentPage === 1}
//               >
//                 Previous
//               </button>

//               <div className="flex space-x-1">
//                 {Array.from({ length: totalPages }, (_, i) => i + 1).map((num) => (
//                   <button
//                     key={num}
//                     onClick={() => setCurrentPage(num)}
//                     className={`h-8 w-8 text-sm font-medium rounded-md ${
//                       currentPage === num
//                         ? "bg-blue-600 text-white shadow-sm"
//                         : "bg-white text-gray-700 hover:bg-gray-100 border border-gray-300"
//                     }`}
//                   >
//                     {num}
//                   </button>
//                 ))}
//               </div>

//               <button
//                 className="px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
//                 onClick={() => setCurrentPage((p) => Math.min(totalPages, p + 1))}
//                 disabled={currentPage === totalPages}
//               >
//                 Next
//               </button>
//             </div>
//           </>
//         )}
//       </div> {/* End of max-w-7xl mx-auto div */}
//     </div>
//   );
// }

// export default PendingApprovalList;